import React from 'react';
import query from '@catalogo/core-graphql-cache/src/local/config/config.graphql';
import { useApolloClient } from '@apollo/client';

export const withConfig = Component => {
  const InnerComponent = props => {
    const config = useConfig();

    return <Component {...props} config={config} />;
  };

  return InnerComponent;
};

export const useConfig = () => {
  const client = useApolloClient();
  const { config } = readConfig(client);

  return config;
};

export const readConfig = client =>
  client.readQuery({
    query,
  });
